<script>
    import {Listeners} from "../../../constants/listeners";
    import {nextTick} from "vue";
    import Button from "primevue/button";
    import ActionsContainer from "./actions-container.vue";

    export default {
        data() {
            return {
                rollUp: false,
                style: {},
                selectedTo: [],
            }
        },
        props: {
            showAdd: {
                type: Boolean,
                default() {
                    return true
                }
            },

        },
        mounted: function () {
            this.$emitter.on(Listeners.KS_TABLE_CHECKBOX_SELECTED, eventData => this.selectedTo = eventData);
        },

        methods: {
            deleteSelected() {
                this.$emitter.emit(Listeners.CLUSTER_SHOW_COMPONENT, {
                    component: Listeners.GROUP_POPUP_DELETE_FROM_DOMAINS_OPEN,
                    ids: this.selectedTo
                });
                this.clearSelectedTo();
            },

            addSelected() {
                this.$emitter.emit(Listeners.CLUSTER_SHOW_COMPONENT, {
                    component: Listeners.GROUP_POPUP_IMPORT_FROM_DOMAINS_OPEN,
                    ids: this.selectedTo
                });
                this.clearSelectedTo();
            },

            clearSelectedTo(){
                this.$emitter.emit(Listeners.KS_TABLE_CLEAR_SELECTED_TO);
            },

            handleScroll(){

                if(document.getElementsByClassName('ks-button-panel').length === 0){
                    return;
                }

                let table = document.getElementsByClassName('vuetable')[0],
                    panel = document.getElementsByClassName('ks-button-panel')[0];

                if((window.innerHeight - 200) >= (table.getBoundingClientRect().height + table.getBoundingClientRect().top + 70)){
                    this.style = {
                        top: (table.getBoundingClientRect().height + table.getBoundingClientRect().top + 70) + 'px',
                    }
                }else{
                    this.style = {
                        top: (window.innerHeight - 200) + 'px'
                    };
                }
            }


        },
        computed: {
            panelStyle(){
                return Object.assign({}, this.style, this.rollUp?{padding: '15px', opacity: 0.5}:{});
            },

        },
        watch: {
            selectedTo: function (val) {
                let self = this;
                nextTick(() => {
                    self.handleScroll();
                });

            }
        },

        created: function () {
            window.addEventListener('scroll', this.handleScroll);
            this.handleScroll();

        },
        destroyed: function () {
            window.removeEventListener('scroll', this.handleScroll);
        },
        components: {
            Button,
            ActionsContainer,
        }
    }
</script>

<template>
    <ActionsContainer :panelStyle="panelStyle" :selectedCount="selectedTo.length">
        <template #buttons>
            <Button v-if="showAdd" @click="addSelected" :label="$t('lang.main.table.components.group_domain_action.added_keys')" size="small" />
            <Button @click="deleteSelected" :label="$t('lang.main.table.components.group_domain_action.delete_keys')" size="small" />
            <Button @click="clearSelectedTo" :label="$t('lang.main.btn.clear')" severity="secondary" size="small" />
        </template>
    </ActionsContainer>
</template>
